import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject, OnDestroy, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../app.service';
import { Common } from '../common/common';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';
declare var $;
declare let google;
declare let gtag;
declare const fbq: any;

@Component({
  selector: 'app-propertysingle',
  templateUrl: './propertysingle.component.html',
  styleUrls: ['./propertysingle.component.css'],
})

export class PropertysingleComponent implements OnInit, AfterViewInit, OnDestroy {

  public blogList: any = [];
  public nearplaceList: any = [];
  public mapData: any;
  public mapLoader: boolean = false;
  public previous: any;
  public leadTableName: string;
  public similiarPoperties: any = [];
  data: any = {};
  loader: boolean = false;
  lat: number;
  lng: number;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    private route: ActivatedRoute,
    private router: Router,
    private service: AppService,
    private common: Common) {
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (document.body.scrollTop > 200 ||
      document.documentElement.scrollTop > 200) {
      document.body.classList.add("scrollclass");
    } else {
      document.body.classList.remove("scrollclass");
    }
  }

  ngOnInit() {
    if(environment.production){
    this.service.sendEvents("Completepropertysingle", "propertysingle", "PropertySingle");

    fbq('track', "CompletePropertySingle" , {
      content_type: "propertysingle",
      content_title: this.router.url,
    });
  }

    this.route.data.subscribe(data => {
      if (data.property_type_name == 'pg') {
        this.getPgPropertyDetails();
      } else {
        this.getPropertyDetails();
      }
    })

    if (isPlatformBrowser(this.platformId)) {
      $('body').attr({
        "data-spy": 'scroll',
        "data-target": '.navbar',
        "data-offset": '50'
      });
    }

  }
  

  ngAfterViewInit() {
    this.getBlogList();
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      $('body').removeAttr('data-spy data-target data-offset');
    }
  }

  loadScript() {
    this.service.loadScript('assets/js/propertysingle/slick.min.js').onload = (teste) => {
      this.service.loadScript('assets/js/propertysingle/jquery.fancybox.min.js').onload = (teste) => {
        this.service.loadExternalStyles('assets/css/propertysingle/fancybox.min.css');
        this.runSlider();
      }
    };

  }

  googleFacbookAnyalytics(property_type:any,looking_type:any,action,slug,propertyID,property_price){

        var lookingType;
      if(looking_type == "1"){
        lookingType = "Residential"
      }else if(looking_type == "2"){
        lookingType = "Commercial"
      }else if(looking_type == "3"){
        lookingType = "Agriculture"
      }else if(looking_type == "4"){
        lookingType = "Industrial"
      }

      gtag('config', environment.gtagId, {
        'page_path': 'https://www.propira.com/'+ slug
      });
      if(property_type == "1"){
        this.service.sendEvents(
          action,
          lookingType,
          "Rent"
        );
        this.triggerfacebookAnalytics(slug,"Rent",lookingType,propertyID,action,property_price);
      }else if(property_type == "2"){
        this.service.sendEvents(
          action,
          lookingType,
          "Buy"
        );
       this.triggerfacebookAnalytics(slug,"Buy",lookingType,propertyID,action,property_price);
      }else if(property_type == "3"){
        this.service.sendEvents(
          action,
          lookingType,
          "Pg"
        );
        this.triggerfacebookAnalytics(slug,"Pg",lookingType,propertyID,action,property_price);
      }
}

triggerfacebookAnalytics(slug,eventCategory,lookingType,propertyID,events,property_price){
  var selectedCityData = JSON.parse(localStorage.getItem('selSearchCity'));
  const eventIDs = [selectedCityData.name,propertyID];
  fbq(
    'init', environment.fbId, {
    'track': 'https://www.propira.com/'+slug
  }
  );
  fbq('track',events,{
    content_ids:eventIDs,
    content_category:eventCategory,
    content_type:lookingType,
    content_price:property_price
});

}

  getPropertyDetails() {
    var propertySlug = this.route.snapshot.paramMap.get('slug');

    this.loader = true;
    this.service.get('/getPropertyDetails?slug=' + propertySlug).subscribe(
      data => {
        console.log(data);
        if (!data[0].error) {
          this.data = data[0].result;
          if(environment.production){
            this.googleFacbookAnyalytics(this.data.property_type,this.data.looking_type,"ViewContent",this.data.property_slug,this.data.propertyid_no,this.data.expected_price);
          }

          this.lat = data[0].result.location_lat;
          this.lng = data[0].result.location_long;

          this.leadTableName = 'tbl_property';

          this.getSimiliarVerifiedProperties();

          this.service.setTitle(data[0].result.meta_title);
          this.service.setMetaTags({ property: "og:type", content: 'Property' });
          this.service.setMetaTags({ property: "og:title", content: data[0].result.title_first + data[0].result.title_second + " | Propira" });
          this.service.setMetaTags({ property: "og:image", content: data[0].result.images[0] });
          this.service.setMetaTags({ name: "keywords", content: data[0].result.meta_keywords });
          this.service.setMetaTags({ name: "description", content: "Discover " + data[0].result.title_first + data[0].result.title_second + " With Propira." + " Find Details: " + "property type - " + data[0].result.title_first + ", Area - " + data[0].result.area + "Room " + data[0].result.room + ". Visit now!"});
          this.service.setMetaTags({ property: "og:description", content: "Discover " + data[0].result.title_first + data[0].result.title_second + " With Propira." + " Find Details: " + "property type - " + data[0].result.title_first + ", Area - " + data[0].result.area + "Room " + data[0].result.room + ". Visit now!"});

          this.loadScript();
        } else {
          this.router.navigateByUrl('/404');
        }
        this.loader = false;
      },
      error => {
        this.router.navigateByUrl('/404');
        this.loader = false;
      }
    )
  }

  getPgPropertyDetails() {
    var propertySlug = this.route.snapshot.paramMap.get('slug');

    this.loader = true;
    this.service.get('/getPgPropertyDetails?slug=' + propertySlug).subscribe(
      data => {
        if (!data[0].error) {
          this.data = data[0].result;
          this.lat = data[0].result.location_lat;
          this.lng = data[0].result.location_long;

          this.leadTableName = 'tbl_payingguest';

          this.getSimiliarVerifiedProperties();

          this.service.setTitle(data[0].result.meta_title);
          this.service.setMetaTags({ property: "og:type", content: 'Property' });
          this.service.setMetaTags({ property: "og:title", content: data[0].result.title_first +  data[0].result.title_second + "| Propira"});
          this.service.setMetaTags({ property: "og:image", content: data[0].result.images[0] });
          this.service.setMetaTags({ name: "keywords", content: data[0].result.meta_keywords });
          this.service.setMetaTags({ name: "description", content: data[0].result.title_first + data[0].result.title_second + "is priced at " + this.service.numDifferentiation(data[0].result.expected_price).replace(/\s/g, "") + " per Month" + ". Specification -" + data[0].result.description + "Visit Now!"});
          this.service.setMetaTags({ property: "og:description", content: data[0].result.title_first + data[0].result.title_second + "is priced at " + this.service.numDifferentiation(data[0].result.expected_price).replace(/\s/g, "") + "per Month" + ". Specification -" + data[0].result.description + "Visit Now!"});

          this.loadScript();
        } else {
          this.router.navigateByUrl('/404');
        }
        this.loader = false;
      },
      error => {
        this.router.navigateByUrl('/404');
        this.loader = false;
      }
    )
  }

  runSlider() {
    $('#detail .main-img-slider').slick({
      slidesToShow: 1,
      infinite: true,
      arrows: true,
      fade: true,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 100,
      lazyLoad: 'ondemand',
      prevArrow: '<div class="slick-prev"><i class="ti-angle-left"></i></div>',
      nextArrow: '<div class="slick-next"><i class="ti-angle-right"></i></div>'
    });


    //keeps thumbnails active when changing main image, via mouse/touch drag/swipe
    $('.main-img-slider').on('afterChange', function (event, slick, currentSlide, nextSlide) {
      //remove all active class
      $('.thumb-nav .slick-slide').removeClass('slick-current');
      //set active class for current slide
      $('.thumb-nav .slick-slide:not(.slick-cloned)').eq(currentSlide).addClass('slick-current');
    });
  }


  sharePost(type, url) {
    this.common.sharePost(type, url);
  }


  get chkPropertyWishlist() {
    if (this.service.isLoggedIn()) {
      if (this.leadTableName == 'tbl_property') {
        return this.service.getPropertyWishlistId.split(',');
      } else {
        return this.service.getPayingGuestWishlistId.split(',');
      }
    } else {
      return "";
    }
  }

  get chkPropertyWishlistId() { return (this.service.getPropertyWishlistId).split(','); }

  get getPayingGuestWishlistId() { return (this.service.getPayingGuestWishlistId).split(','); }


  addToWishlist(property_type, property_id, event) {
    if (this.service.isLoggedIn()) {
      if (event.srcElement.classList.contains('fa-heart-o')) {
        event.srcElement.classList.remove('fa-heart-o');
        event.srcElement.classList.add('fa-heart');

        this.service.notificationPopup('success', 'Property successfully added in wishlist.');
      } else {
        event.srcElement.classList.remove('fa-heart');
        event.srcElement.classList.add('fa-heart-o');

        this.service.notificationPopup('success', 'Property successfully removed to wishlist.');
      }
      this.service.post('/addPropertyWishlist', { "type": "Web", "auth_token": this.service.getAuthorizationToken(), "property_type": property_type, "property_id": property_id }).subscribe(

        data => {
          if (data[0].error == '0') {
            if (property_type == '1' || property_type == '2') {
              var profileData = JSON.parse(localStorage.getItem('currentUser'));
              profileData.property_wishlistid = data[0].property_id;
              localStorage.setItem('currentUser', JSON.stringify(profileData));
            } else {
              var profileData = JSON.parse(localStorage.getItem('currentUser'));
              profileData.payingguest_wishlistid = data[0].property_id;
              localStorage.setItem('currentUser', JSON.stringify(profileData));
            }
          } else {
            this.service.messageBox('failed', 'Something went wrong.please try again.');
          }
        },
        error => {
          this.service.messageBox('failed', 'Something went wrong.please try again.');
        }
      )
    } else {
      $('#loginModal').modal('toggle');
    }

  }


  searchFeatureTypeValue(id) {
    var idString = this.data.furnished_type;
    var idArray = idString.split(',');

    var searchValue = idArray.filter(function (keyData) {
      return keyData == id;
    });

    if (searchValue.length > 0) {
      return searchValue[0];
    }
  }


  getMealTypeName(meal_type) {
    return this.common.typeOfMealValue(meal_type);
  }

  getBlogList() {
    this.service.get('/homepageFeatBlog').subscribe(
      data => {
        if (data[0].error == '0') {
          this.blogList = data[0].result;

          setTimeout(function () {
            $(".latest-blog").owlCarousel({
              navigation: false,
              pagination: true,
              slideSpeed: 600,
              paginationSpeed: 400,
              autoPlay: false,
              items: 1,
              itemsDesktop: [1199, 1],
              itemsDesktopSmall: [979, 1],
              itemsTablet: [767, 1],
              itemsMobile: [480, 1],
              navigationText: ['<i class="icon-left-open"><i class="fa fa-angle-left"></i></i>', '<i class="icon-right-open"><i class="fa fa-angle-right"></i></i>']
            });
          }, 3000);

        } else {
          this.blogList = [];
        }
      },
      error => {
        console.log('in error');
      }
    )
  }

  setmap(event: any) {
    this.mapData = event;
    this.findPlaces('school');
  }

  findPlaces(types) {
    var cur_location = new google.maps.LatLng(this.lat, this.lng);

    // prepare request to Places
    var request = {
      location: cur_location,
      radius: 1000,
      types: [types]
    };

    this.nearplaceList = [];
    this.previous = "";
    this.mapLoader = true;
    $('.placelinks').removeClass('active');
    $('.' + types + 'nearplace').addClass('active');

    var service = new google.maps.places.PlacesService(this.mapData);
    service.nearbySearch(request, (results, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        this.nearplaceList = results;
      } else if (status == google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
      }

      this.mapLoader = false;
    });
  }

  clickedMarker(infowindow) {
    if (this.previous) {
      this.previous.close();
    }
    this.previous = infowindow;
  }

  scrollTo(section) {
    document.querySelector('#' + section)
      .scrollIntoView();

    return false;
  }

  getSimiliarVerifiedProperties() {
    var cond = "";
    if (this.data.property_type == '1' || this.data.property_type == '2') {
      cond += "/getBuySellRelatedProperties?property_id=" + this.data.property_id + "&property_type=" + this.data.property_type + "&looking_type=" + this.data.looking_type + "&looking_subcat_type=" + this.data.looking_subcat_type + "&looking_subcat_type_value=" + this.data.looking_subcat_type_value+"&expected_price="+this.data.expected_price+"&city_id=" + this.service.getSelectedCity.id;
    } else {
      cond += "/getPgRelatedProperties?payingguest_id=" + this.data.property_id + "&property_type=3" + "&city_id=" + this.service.getSelectedCity.id;
    }

    this.service.get(cond).subscribe(
      (data: any) => {
        if (data[0].error == '0') {
          this.similiarPoperties = data[0].result;
        }
      }, error => {
        console.log(error.errorDesc);
      }
    )
  }

}
